// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 718
// module chunks = 0